exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head-section h6{color:#223279;font-weight:400}.top_nav a:hover,.top_nav a.active{border-bottom:3px solid #252474;color:#252474}.navbtn_position{position:absolute;right:10px;top:0px}.m-tb{margin:30px 0px !important}.pt{padding-top:20px}.comparison_heading{font-size:20px;font-weight:400}.portfolio__searchBox>div:first-child{margin:auto}.portfolio__searchBox input{width:430px;height:25px}.portfolio__searchBox i{margin-left:10px;color:#252474;cursor:pointer}.portfolio__searchBox>div>ul{position:absolute;width:450px;height:200px;overflow:auto;background-color:aliceblue;border:1px solid gray;z-index:999;margin-left:auto;margin-right:auto;left:0;right:0;text-align:center}.portfolio__searchBox>div>ul>li{padding:5px;cursor:pointer;border-bottom:1px solid gray}.portfolio__searchBox .spinner{display:inline-block}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/portfolio.scss
// module id = 1503
// module chunks = 0